module.exports = __webpack_public_path__ + "media/general_icons/search-ba045115.svg";